import CallToAction from "~/components/CallToAction";
import CanonicalLink from "~/components/CanonicalLink";
import Description from "~/components/Description";
import Integrations from "~/components/Integrations";
import StructuredDataOrganizationSchema from "~/components/StructuredDataOrganizationSchema";
import Testimonials from "~/components/Testimonials";
import Title from "~/components/Title";
import Hero from "./Hero";
import Services from "./Services";
import Statistics from "./Statistics";

export default function Home() {
  return (
    <>
      <Title>Website monitoring, cron job monitoring and eye candy hosted status pages</Title>

      <Description>
        Explore WebGazer for reliable uptime and cron job monitoring, plus customizable status pages. Trusted globally for enhancing website
        performance and uptime.
      </Description>

      <CanonicalLink path="/" />

      <StructuredDataOrganizationSchema />

      <Hero />

      <Services />

      <Integrations />

      <Testimonials />

      <Statistics />

      <CallToAction
        body={(
          <>
            Monitor your infrastructure with WebGazer and get alerted when something breaks. Setup WebGazer, sit back, and enjoy the peace
            of mind.
          </>
        )}
        title="Ready to get started?"
      />
    </>
  );
}

export const Component = Home;
